(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('communique', {
            parent: 'application',
            url: '/communique',
            data: {
                authorities: ['CLIENT_RESOURCE'],
                pageTitle: 'Communique - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/communique/communique.html',
                    controller: 'CommuniqueController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
